import { Box, Button, Card, Grid, Text, Title } from '@mantine/core';
import { IconUserPlus } from '@tabler/icons-react';
import influencersImage from '../assets/images/spradz-influencers.png';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';

const SpradzInfluencersPage = () => {
  const handleRedirect = () => {
    const spradzExternalLink = 'https://spradz.com/influencer/list.php';
    window.open(spradzExternalLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Metadata title={`${Page['influencers']}`} />
      <Card withBorder>
        <Grid align="center" justify="flex-start">
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <Box ta="right">
              <Title order={5} mb="sm">
                <strong>Connect with Spradz Influencers</strong>
              </Title>
              <Button size="sm" onClick={handleRedirect}>
                <IconUserPlus size={16} />
                <Box component="span" visibleFrom="md" display="inline">
                  {' '}
                  Connect
                </Box>
              </Button>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 5 }}>
            <img src={influencersImage} alt="spradzInfluencers" className="img-fluid" />
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
};

export default SpradzInfluencersPage;
